<template>
    <span>
        <b-button
            v-show="isEditEnabled"
            class="align-baseline mr-2"
            title="Edit"
            variant="default"
            @click="onEditModalOpen"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            v-show="isDeleteEnabled"
            class="align-baseline"
            title="Delete"
            variant="default"
            @click="isDeleteDialogShown = true"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            id="configuration-option-delete-modal"
            title="Delete"
            ok-title="Delete"
            @hide="isDeleteDialogShown = false"
            @cancel="isDeleteDialogShown = false"
            @ok="onDelete"
            :visible="isDeleteDialogShown"
            >Are you sure you want to delete '{{
                selectedItem.name || selectedItem.title
            }}'?</modal
        >
    </span>
</template>

<script>
    import API from '../../../api';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        data() {
            return {
                isDeleteDialogShown: false,
                isEditEnabled: true,
                isDeleteEnabled: true,
            };
        },
        computed: {
            selectedItem() {
                return this.params.data;
            },
        },
        beforeMount() {
            if (this.params.cellType === 'job-types') {
                this.isEditEnabled = this.isDeleteEnabled = !this.params.data
                    .is_default;
            }
            if (this.params.cellType === 'expense-accounts') {
                this.isDeleteEnabled = !this.params.data.is_default;
            }
        },
        methods: {
            onEditModalOpen() {
                if (this.params && this.params.modalData) {
                    this.params.modalData.openEditModal(
                        'edit',
                        this.params.data
                    );
                }
            },
            onDelete() {
                this.params.modalData.onDelete(this.params.data);
            },
        },
    };
</script>
